import { h, Component, Prop } from '@stencil/core';

@Component({
  shadow: true,
  styleUrl: 'igws-flags.less',
  tag: 'igws-flags',
})
export class FlagsComponent {
  /**
   * Is in footer
   */
  @Prop() isFooter!: boolean;
  /**
   * Is in international page
   */
  @Prop() isInternational!: boolean;
  /**
   * Country
   */
  @Prop() country!: string;
  /**
   * Country flag
   */
  @Prop() countryFlag!: string;
  /**
   * Label for flag when in international page
   */
  @Prop() label!: string;
  /**
   * International page path
   */
  @Prop() pagePath!: string;

  @Prop() showFlag: boolean = true;

  render() {
    let countryCode = this.country;
    let flag = this.countryFlag ? `flag--${this.countryFlag}` : this.country ? `flag--${this.country}` : '';
    flag += this.showFlag ? '' : ' flag--none';

    if (this.country === 'zh') {
      countryCode = '简体中文';
    } else if (this.country === 'cn') {
      countryCode = '繁體中文';
    }

    if (this.isInternational) {
      return (
        <a class={flag} href={this.pagePath}>
          <span>{this.label}</span>
        </a>
      );
    } else if (this.country === 'esp' || this.country === 'rus') {
      return null;
    } else {
      return (
        <a class={flag} href={this.pagePath}>
          {this.isFooter ? <span>{countryCode.toUpperCase()}</span> : ''}
        </a>
      );
    }
  }
}
